import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {black} from '/theme/color/on.color';
import {denim} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    flexDirection: 'row' as const,
    justifyContent: 'flex-start' as const,
    alignItems: 'center' as const,
  },
  dataContainer: {
    flexShrink: 0,
    flexGrow: 1,
  },
  dataAndRightIconContainer: {
    flexDirection: 'row' as const,
    justifyContent: 'flex-start' as const,
    alignItems: 'center' as const,
    flex: 1,
  },
  iconColumn: {
    marginRight: indent * 0.2,
    fontSize: 18,
  },
  iconFlex: {
    marginRight: 20,
  },
  firstRowContainer: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
  },
  labelRow: {
    marginBottom: 2,
  },
  valueRow: {
    marginTop: 2,
    flexWrap: 'nowrap' as const,
  },
  valueRowDisposition: {
    marginTop: 2,
    color: black,
  },
  coachvalueRow: {
    marginTop: 2,
    color: denim,
  },
  arrowIcon: {
    alignItems: 'flex-end' as const,
    marginTop: 7,
  },
});
